import { StandardEvents } from '@shopify/events';

const selections = new Map();
const mixingRequests = new Map();

class ClawsCustomColour extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.root = this.closest('.shopify-section, dialog, product-card');
    this.key = this.dataset.selectionKey;
    this.pending = false;
    const { signal } = this.controller;
    const saved = selections.get(this.key);
    for (const input of this.querySelectorAll('input[type="radio"]')) {
      input.checked = input.value === saved;
    }
    const mixingInput = this.querySelector('textarea');
    mixingInput.value = mixingRequests.get(this.key) || '';
    mixingInput.addEventListener('input', () => {
      mixingRequests.set(this.key, mixingInput.value);
    }, { signal });
    this.addEventListener('change', () => {
      const selected = this.querySelector('input:checked');
      if (selected) selections.set(this.key, selected.value);
      this.querySelector('[data-colour-error]').hidden = true;
    }, { signal });
    this.root?.addEventListener('change', (event) => {
      if (event.target.closest('variant-picker')) this.sync();
    }, { signal });
    this.root?.addEventListener(StandardEvents.productSelect, async (event) => {
      this.pending = true;
      try { await event.promise; } catch {} finally {
        this.pending = false;
        if (this.isConnected) this.sync();
      }
    }, { signal });
    this.sync();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  sync() {
    const picker = this.root?.querySelector('variant-picker[data-product-id="' + this.dataset.productId + '"]');
    const selected = picker ? Array.from(picker.querySelectorAll('input:checked, select')).some(input => input.value === 'Custom Colour') : this.dataset.initialCustom === 'true';
    this.hidden = !selected;
    for (const input of this.querySelectorAll('input[type="radio"]')) {
      input.disabled = !selected;
      input.required = selected;
    }
    this.querySelector('textarea').disabled = !selected;
    const formComponent = this.closest('product-form-component');
    const express = formComponent?.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
    if (express) {
      express.style.display = selected ? 'none' : '';
    }
  }

  validateSelection() {
    this.sync();
    if (this.hidden) return true;
    const valid = !this.pending && Boolean(this.querySelector('input:checked:not(:disabled)'));
    const error = this.querySelector('[data-colour-error]');
    error.hidden = valid;
    if (!valid) {
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.querySelector('input:not(:disabled)')?.focus({ preventScroll: true });
    }
    return valid;
  }
}

if (!customElements.get('claws-custom-colour')) customElements.define('claws-custom-colour', ClawsCustomColour);
